import styled, { css } from 'styled-components'
import { BoxDefault } from '../../../../components/BoxContainer/styles'

export const BoxBrand = styled.div`
  ${({ onClick }) => css`
    background: var(--background);
    border: 1px solid var(--border-color-table);
    border-radius: 13px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 24px;
    width: 210px;
    min-height: 160px;
    overflow: hidden;
    padding: 16px;
    cursor: ${onClick ? 'pointer' : 'default'};

    h3 {
      margin: 0 !important;
      text-align: center;
      font-size: var(--font-size-md) !important;
      color: var(--text-dark) !important;
      padding-bottom: 16px !important;
      font-weight: 600 !important;
      border-bottom: 1px solid var(--border-dark) !important;
      overflow: hidden;
      width: 100%;
      text-overflow: ellipsis;
      white-space: pre-line;
      word-break: break-word;
    }

    p {
      margin: 0;
      text-align: center;
      font-size: var(--font-size-sm);
      text-overflow: ellipsis;
      width: 100%;
      overflow: hidden;
      color: var(--text-tertiary) !important;
    }
  `}
`

export const BoxContainer = styled(BoxDefault)`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`

export const BoxButton = styled.div`
  padding: 2rem;

  > svg {
    cursor: pointer;
  }
`
